import { Breakpoint, Button, Color, TextArea } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px 25px;
  background-color: ${Color.White};

  @media ${Breakpoint.SmallDesktop} {
    padding: 100px 100px 161px;
  }
`;

export const Separator = styled.div`
  margin: 15px 0 35px;
  width: 100%;
  height: 1px;
  background-color: ${Color.Brand300};
`;

export const StyledTextArea = styled(TextArea)`
  margin: 25px 0 20px;
`;

export const StyledButton = styled(Button)`
  max-width: 200px;
  align-self: flex-end;
`;
